import { API, Helpers, Router } from '../Helpers';
//import { Checkbox, Radio, RadioGroup } from 'react-icheck';
//import FroalaEditor from 'react-froala-wysiwyg';
//import { InputHidden, Select } from '../Core';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
//import { ReactSortable } from "react-sortablejs";

export default class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            cart: this.props.data.cart
        };
        
        this.keepAlive = this.keepAlive.bind(this);
        this.orderPageUrl = this.orderPageUrl.bind(this);
        this.renewCart = this.renewCart.bind(this);
        this.updateCart = this.updateCart.bind(this);
    }
    
    componentDidMount()
    {
        setInterval(() => this.keepAlive(), (0.5 * 60 * 1000));
        
        //this.addToCartSubscription = pubsub.subscribe('UPDATE_CART', (data) => 
        //{
            //console.log("addToCartSubscription", data);
            
            //this.updateCart(data);
        //});
    }
    
    orderPageUrl()
    {
        let url = this.props.data.agency.resmarkUrl + "/public/order/index/Order/view";
        
        return url;
    }
    
    keepAlive()
    {
        //console.log('keepAlive');
        
        // this.renewCart();
    }
    
    renewCart()
    {
        //console.log('renewCart');
        
        const router = Router(this.props.data.routes);
        
        let onResponse = {
            success: (response) => 
            {
                this.setState({
                    cart: response
                });
            },
            error: error => 
            {
                console.log('error', error);
            },
            complete: () => 
            {
                console.log('complete');
            }
        }
        
        API.get(onResponse, router.url('api.carts.renew', {cart: this.state.cart.id}));
    }
    
    updateCart(data)
    {
        //console.log("updateCart", data);
        
        this.setState({
            cart: data
        });
    }
        
    render() {
        
        const { agency, agent_id, active_site, csrf_token, env, cart, routes } = this.props.data;
        const router = Router(routes);
        const rm_cart = _.find(active_site.settings.data, (_setting) => { return _setting.key === "rm_cart_script"; })
         
        return (
            <div>
                {
                    _.isEmpty(agency) ?
                    
                        !_.isEmpty(rm_cart) && !_.isEmpty(rm_cart.value) ? 
                        <button class="btn btn-flat">
                            <div dangerouslySetInnerHTML={{__html: rm_cart.value}} />
                        </button> 
                        :
                        <a 
                            href={router.url('cart', {domain: active_site.domain})}
                            className="btn btn-link btn-rounded z-depth-0 white-text font-weight-bold">
                            <i className={"fa fa-lg fa-shopping-bag " + (this.props.data.color ? "" : "primary-text") } style={{ color: this.props.data.color || "" }}></i>
                        </a>
                    :
                    <button className="btn btn-flat">
                        <rm-shopping-cart 
                            order-page-url={this.orderPageUrl()}
                            className="primary-text">
                        </rm-shopping-cart>
                    </button>
                }
            </div>
        );
    }
}

if (document.getElementById('cartButton')) {
    
    const element = document.getElementById('cartButton');
    const data = Object.assign({}, element.dataset);
        
    //console.log(data.data);
    
    ReactDOM.render(<App data={JSON.parse(data.data)} />, document.getElementById('cartButton'));
}



// WEBPACK FOOTER //
// ./resources/js/components/CartWidget/App.js